/**
 * Returns the ObjectId string from a value that may be either a populated
 * Mongoose document (`{ _id, ... }`) or already a bare ObjectId string.
 *
 * Use this whenever building API payloads (PUT/POST) for fields that hold an
 * ObjectId reference — populated objects sent as-is cause Mongoose to throw
 * `Cannot create Buffer` CastErrors. See CLAUDE.md → "ID Comparisons & API
 * Payloads".
 */
export default function getObjId<T extends { _id?: string }>(
  item: T | string | null | undefined,
): string | undefined {
  return typeof item === 'object' && item ? item._id : (item as string | undefined);
}
